/* esm.sh - date-fns@4.1.0/_lib/addLeadingZeros */
function r(t,n){let o=t<0?"-":"",a=Math.abs(t).toString().padStart(n,"0");return o+a}export{r as addLeadingZeros};
//# sourceMappingURL=addLeadingZeros.mjs.map